import React, { useState } from "react";
import { UI_BODY_SEMIBOLD_SM } from "oolib";
import { ButtonPrimaryCompact } from "oolib/dist/v2/components/Buttons";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { Card, Actions, EditToggle, EditBody, INHERIT_CURSOR } from "./styled";

/**
 * Collapsible "Edit import settings" card in a dataset's manage view. The
 * integration's own fields go in as children, above Save Changes.
 * Starts collapsed.
 */
export const EditImportSettings = ({ children, saveDisabled, onSave }) => {
  const [open, setOpen] = useState(false);
  return (
    // Visible overflow: the v1 date picker's calendar can't portal out and
    // would be cut off by the card's edges. No hover rows here to clip.
    <Card style={{ overflow: "visible" }}>
      <EditToggle onClick={() => setOpen((o) => !o)} $open={open}>
        <Actions style={{ gap: 6 }}>
          <DisplayIcon icon="PencilSimple" size={16} style={INHERIT_CURSOR} />
          <UI_BODY_SEMIBOLD_SM>Edit import settings</UI_BODY_SEMIBOLD_SM>
        </Actions>
        <DisplayIcon
          icon={open ? "CaretUp" : "CaretDown"}
          size={16}
          style={INHERIT_CURSOR}
        />
      </EditToggle>
      {open && (
        <EditBody>
          {children}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ButtonPrimaryCompact disabled={saveDisabled} onClick={onSave}>
              Save Changes
            </ButtonPrimaryCompact>
          </div>
        </EditBody>
      )}
    </Card>
  );
};

export default EditImportSettings;
